import { createSlice } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const initialState = {};

const setAbTests = (draft, action) => {
  const {
    abTests
  } = action.payload;
  abTests.forEach(test => {
    draft[test.name] = test;
  });
};

const abTestsSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setAbTests
  }
});
export const {
  actions
} = abTestsSlice;
export const plug = {
  [stateName]: abTestsSlice.reducer
};
export default abTestsSlice.reducer;